import {
    Button,
    ButtonGroup,
    DialogBody,
    DialogContainer,
    DialogFooter,
    DialogHeader,
    Icon,
    Textarea
} from '@wg/wows-react-uikit'
import { t } from 'helpers/localization'
import React, { PureComponent } from 'react'
import Terms from '../Terms/Terms'
import styles from './ApplicationDialog.scss'


export type ApplicationDialog_Props = {
    leftApplicationCount: number,

    hideDialog: () => void,
    sendApplication: (info: String) => void,
}

class ApplicationDialog extends PureComponent<ApplicationDialog_Props, any> {

    constructor(props) {
        super(props)

        this.state = {
            info: '',
        }

        this.updateInfo = this.updateInfo.bind(this)
        this.sendApplication = this.sendApplication.bind(this)
    }

    updateInfo(info: String) {
        this.setState({...this.state, info})
    }

    sendApplication() {
        this.props.sendApplication(this.state.info)
        this.props.hideDialog()
    }

    render() {



        const leftApplicationsMessage = this.props.leftApplicationCount === 0 ? t('На сегодня у вас не осталось заявок в кланы') : t('Оставшееся количество заявок в кланы на сегодня: %(count)s', {count: this.props.leftApplicationCount})

        return (
            <DialogContainer>
                <DialogHeader>
                    {t('Заявка на вступление')}
                </DialogHeader>
                <DialogBody>
                    <div className={styles.wrapper}>
                        <Textarea
                            label={t('Почему клан должен выбрать вас?')}
                            onChange={this.updateInfo}
                            value={this.state.info}
                            width="100%"
                            height="130px"
                            maxLength={500}
                            isCounted />
                        <span className={styles.infoLabel}><Icon glyph="info" /> {t('Заявку будут рассматривать офицеры клана')}</span>
                        <Terms />
                        <span className={styles.leftApplicationsLabel}>{leftApplicationsMessage}</span>
                    </div>
                </DialogBody>
                <DialogFooter>
                    <ButtonGroup>
                        <Button
                            isJustified
                            onClick={this.sendApplication}>
                            {t('Отправить заявку')}
                        </Button>
                        <Button isJustified onClick={this.props.hideDialog}>{t('Отмена')}</Button>
                    </ButtonGroup>
                </DialogFooter>
            </DialogContainer>
        )
    }
}

ApplicationDialog.defaultProps = {
    leftApplicationCount: 0,

    hideDialog: () => {},
    sendApplication: (info: String) => {},
}

export default ApplicationDialog